export const deleteListErrorId = 'deleteListError';
export const useListsQueryErrorId = 'useListsQueryError';
